import { all } from 'redux-saga/effects';
import auth from './authSaga';
import call from './callSaga';
import chatsSaga from './chats';
import clsSaga from './clsSaga';
import feed from './feedSaga';
import followers from './followersSaga';
import postSaga from './postSaga';
import org from './profileSaga';
import restoreAccount from './restoreAccountSaga';
import savedSearch from './savedSearchSaga';
import searchItem from './searchItemSaga';
import search from './searchSaga';
import signUp from './signUpSaga';
import theme from './themeSaga';
import upload from './uploadSaga';
import user from './userSaga';

export default function* rootSaga() {
  yield all([
    user(),
    auth(),
    call(),
    feed(),
    chatsSaga(),
    clsSaga(),
    restoreAccount(),
    search(),
    searchItem(),
    theme(),
    signUp(),
    org(),
    upload(),
    postSaga(),
    followers(),
    savedSearch(),
  ]);
}
